import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { SettingsEnum } from '../../model/settings.enum';
import { FacadeService } from '../../service-facade/facade.service';
import { CoreService } from '../../services/core.service';

@Component({
  selector: 'app-app-store-banner',
  templateUrl: './app-store-banner.component.html',
  styleUrls: ['./app-store-banner.component.css']
})
export class AppStoreBannerComponent implements OnInit {
  brand = "";
  appStoreLink: SafeUrl = "";
  googlePlayLink: SafeUrl = "";
  isMobile$: Observable<boolean>;

  constructor(
    public coreService: CoreService,
    private _facade: FacadeService,
    private _domSanitazer: DomSanitizer,
  ) {
    this.isMobile$ = this._facade.isMobile$;
  }

  ngOnInit(): void {
    this._setupAppLinks();
  }

  private _setupAppLinks(): void {
    const appStoreLink = this._facade.getStorageItem(SettingsEnum.AppStoreLink);
    const googlePlayLink = this._facade.getStorageItem(SettingsEnum.GooglePlayLink);

    if (appStoreLink) {
      this.appStoreLink = this._domSanitazer.bypassSecurityTrustUrl(appStoreLink);
    }

    if (googlePlayLink) {
      this.googlePlayLink = this._domSanitazer.bypassSecurityTrustUrl(googlePlayLink);
    }
  }
}
